export default "__VITE_ASSET__x$TZiN8$__"